// extracted by mini-css-extract-plugin
export default {"background":"welcome_background__C5Gtd","wrapper":"welcome_wrapper__qXnX1","title":"welcome_title__CSbsj","inventia":"welcome_inventia__xMuRd"};